import { ChangeDetectorRef, Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { ImportToType } from "../../../../../objects/calculator/public/types/type";
import { Order } from "../../../../../objects/orders/order";
import { WizardComponent } from "ngx-wizard";
import { CalculatorType } from "../../../../../objects/orders/calculatorType";
import { CalculatorHelper } from "../../../../../common/helpers/calculatorHelper";
import { OrderLocation } from "../../../../../objects/management/order/orderLocation";
import { ScreenHelper } from "../../../../../common/helpers/screenHelper";
import { GoogleTagService } from "../../../../../services/google-tag.service";
import { OrderItem } from "../../../../../objects/orders/orderItem";
import { OrderOptions } from "../../../../../objects/orders/orderOptions";
import { ShipmentFromTabComponent } from "../shipment-from-tab/shipment-from-tab.component";
import { PageVisit } from "../../../../../objects/pages/pageVisit";

@Component({
    selector: "locationTo-tabs-v2",
    templateUrl: "./locationTo-tab-v2.component.html",
    host: {
        '(window:resize)': 'checkIfMobile()'
    },
    moduleId: module.id.toString()
})
export class LocationToTabsV2Component {
    @Input()
    public order: Order;
    @Input()
    public orderItem: OrderItem;
    @Input()
    public wizardComponent: WizardComponent;
    @Input()
    public provinceArray: Array<any> = new Array<any>();
    @Output()
    public hideWizard: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public setOrderItem: EventEmitter<OrderItem> = new EventEmitter<OrderItem>();

    @Input()
    public wizardFooterTemplate: TemplateRef<any>;

    @Input()
    public showFirstTab: boolean = false;

    @Input()
    public isSelfServeApp: boolean = false;

    @Input()
    public shipmentFrom: ShipmentFromTabComponent;

    @Input()
    public focusInput: any;
    @Input()
    public isVehicle: any;
    @Output()
    public onTabSelected: EventEmitter<PageVisit> = new EventEmitter<PageVisit>();

    public currentLocationTo: ImportToType = null;
    public currentState: string;
    public importToTypeRef = ImportToType;
    public isMobile: boolean;

    public get isCanadianCalculator(): boolean {
        return CalculatorHelper.getCalculatorType(this.order.Locations) == CalculatorType.CanadianImport;
    }

    constructor(private detectChanges: ChangeDetectorRef,
                public googleTagService: GoogleTagService) {
    }

    public setImportTo(importToType: ImportToType): void {
        if (this.currentLocationTo == importToType) {
            this.currentLocationTo = null;
            return;
        }

        this.currentLocationTo = importToType;

        this.detectChanges.detectChanges();
    }

    public setCountryToOrder(event: any): void {
        event.preventDefault();

        let location: OrderLocation = new OrderLocation({
            Type: 2
        });

        let orderLocation = this.order.Locations.find(loc => loc.Type == 2);

        if (orderLocation)
            location = orderLocation;

        if(this.order && !this.order.Flag){
            this.order.Flag = OrderOptions.None;
        }

        switch (this.currentLocationTo) {
            case ImportToType.Canada:
                location.Country = "Canada";
                if(this.order.Flag.hasFlag(OrderOptions.IsCommercialCarrier))
                    this.order.Flag &= ~ OrderOptions.IsCommercialCarrier;

                if(this.order.Flag.hasFlag(OrderOptions.IsDrivingAcross))
                    this.order.Flag &= ~ OrderOptions.IsDrivingAcross;

                this.shipmentFrom.showUSABtn = true;
                this.shipmentFrom.showCanadaBtn = false;
                break;
            case ImportToType.Usa:
                location.Country = "United States";
                if (this.order.Locations.length > 0) {
                    this.order.Locations[0].State = null;
                }
                this.shipmentFrom.showUSABtn = false;
                this.shipmentFrom.showCanadaBtn = true;
                break;
        }


        console.log(this.order.Flag);
        this.order.Locations = [ ...this.order.Locations.filter(x => x.Type != 2), location ];

        setTimeout(_ => {
            this.wizardComponent.nextTab(false);
        }, 100);

    }

    public setProvincial(provincial: any /*TODO create an object*/): void {
        let orderLocation = this.order.Locations.find(loc => loc.Type == 2);

        orderLocation.State = provincial.name;

        if (provincial == this.currentState) {
            this.currentState = null;
            return;
        }

        this.currentState = provincial;

        this.detectChanges.detectChanges();
    }

    public checkIfMobile(): void {
        this.isMobile = ScreenHelper.isTabletOrPhone();
    }

    public backToCalculatorFirstPage() {
        if(!this.showFirstTab){
            this.hideWizard.emit(true);
            this.setOrderItem.emit(this.orderItem);
        }

    }

    setToCanadaImport(): void {
        if (!this.isSelfServeApp) {
            return;
        }

        this.setImportTo(ImportToType.Canada);
        setTimeout(() => this.wizardComponent.nextTab(true), 0);
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/locationTo-tab/locationTo-tab-v2.component.ts